/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.19.1-30-g35acb1d6-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LdapUserResponse interface.
 */
export function instanceOfLdapUserResponse(value) {
    if (!('username' in value) || value['username'] === undefined)
        return false;
    if (!('dn' in value) || value['dn'] === undefined)
        return false;
    return true;
}
export function LdapUserResponseFromJSON(json) {
    return LdapUserResponseFromJSONTyped(json, false);
}
export function LdapUserResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'dn': json['dn'],
    };
}
export function LdapUserResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
        'email': value['email'],
        'display_name': value['displayName'],
        'dn': value['dn'],
    };
}
